export enum RoutePath {
  Home = '/',
  Welcome = '/welcome',
  NetworkTest = '/networktest',
  TestComplete = '/testcomplete',
  RouterSpeedProgress = '/routerspeedprogress',
  RouterSpeedCompleted = '/routerspeedcomplete',
  OnlineActivitiesQ1 = '/onlineactivitiesQ1',
  WifiQ2 = '/wifiQ2',
  WifiLoading = '/wifiloading',
  Results = '/results',
  Profile = '/profile',
}
